import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { ParametrizacionService } from '../../../services/parametrizacion.service';
import {
  IModificarParametroRequest,
  ParametrizacionUpdateEvent,
} from '../../../dto/expediente/parametrizacion.dto';
import { UtilService } from '../../../services/util.service';

const FORM_VALIDATION_RULES = {
  nombre: [{ value: '', disabled: true }, Validators.required],
  descripcion: [{ value: '', disabled: true }, Validators.required],
  valor: ['', Validators.required],
};

@Component({
  selector: 'app-form-editar-parametrizacion',
  templateUrl: './form-editar-parametrizacion.component.html',
  styleUrl: './form-editar-parametrizacion.component.scss',
})
export class FormEditarParametrizacionComponent {
  @Output() parametrizacionActualizado = new EventEmitter<void>();
  @ViewChild('modalParametrizacion', { static: false })
  modalParametrizacion!: ElementRef;
  parametrizacionId = 0;
  formulario: FormGroup;
  role: null | string = null;

  constructor(
    private fb: FormBuilder,
    private parametrizacionService: ParametrizacionService,
    private alertService: AlertaModalService,
    private utilService: UtilService
  ) {
    this.formulario = this.fb.group(FORM_VALIDATION_RULES);
  }

  editarParametrizacion(event: ParametrizacionUpdateEvent) {
    this.openModal();
    this.parametrizacionId = event.item.id_parametro;
    this.role = this.utilService.getRole();
    this.updateFormValues(event);
  }

  onGuardar() {
    const updatedData: IModificarParametroRequest = this.formulario.value;
    this.parametrizacionService
      .modificarParametrizacion(this.parametrizacionId, this.role!, updatedData)
      .subscribe({
        next: async () => {
          await this.alertService.exito('Parametro actualizado correctamente');
          this.parametrizacionActualizado.emit();
        },
        error: async () => {
          await this.alertService.error(
            'Ocurrió un error al intentar modificar el parametro. Por favor, inténtelo de nuevo.'
          );
        },
      });
  }

  private openModal(): void {
    this.modalParametrizacion.nativeElement.click();
  }

  private updateFormValues(event: ParametrizacionUpdateEvent): void {
    if (event?.item) {
      this.formulario.patchValue({
        valor: event.item.valor_parametro || '',
        nombre: event.item.nombre_parametro || '',
        descripcion: event.item.descripcion || '',
      });
    }
  }
}
